<template>
  <div class="thanks">
    <div class="thanks__image">
      <img :src="options.thankYou.img" :alt="options.thankYou.title" />
    </div>
    <block-heading
      :selector="`thanks`"
      :title="options.thankYou.title"
      :text="options.thankYou.text"
    />

    <div class="thanks__retailer thanks-retailer">
      <p class="thanks-retailer__text"
         v-if="retailer.name"
         v-html="retailer.name"></p>
      <div class="thanks-retailer__description retailer-description">
        <div class="retailer-description__item"
             v-if="retailer.address">{{retailer.address}}</div>
        <a class="retailer-description__item" :href="`tel:`+retailer.phone"
           v-if="retailer.phone">{{retailer.phone}}</a>
        <a class="retailer-description__item" :href="`mailto:`+retailer.email"
           v-if="retailer.email">{{retailer.email}}</a>
      </div>
    </div>

    <div class="thanks__buttons" v-if="options.btn[0]">
      <button-theme
        :mode="`transparent`"
        :size="`s`"
        :width="229"
        :href="options.btn[0].link"
        :label="options.btn[0].name"
        :name="options.btn[0].name"
      />
    </div>
    <!--    <div class="thanks__wrapper">-->
    <!--      -->
    <!--    </div>-->
  </div>
</template>

<script>
import blockHeading from './blockHeading.vue';
import buttonTheme from './buttonTheme.vue';

export default {
  name: 'popupThanks',
  components: {
    blockHeading,
    buttonTheme,
  },
  computed: {
    options() {
      return this.$store.state.siteData;
    },
    retailer() {
      return this.$store.state.retailer;
    },
  },
  methods: {
    // handleClick(item) {
    //   this.$emit('handleClick', item.label);
    // },
  },
};
</script>

<style lang="scss">
@import '../../../sass/setup.scss';

.thanks {
  padding: 87px 10px;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  overflow-y: auto;
  @include clearScrollbar;

  @include up-tablet {
    margin: auto;
    padding: 84px 30px;
    max-width: 441px;
  }

  &__image {
    margin-bottom: 46.18px;
    width: 214.63px;

    @include up-tablet {
      margin-bottom: 15.53px;
      width: 258px;
    }

    & > * {
      width: 100%;
      height: auto;
    }
  }

  &__heading {
    margin-bottom: 22px;

    @include up-tablet {
      //margin-bottom: 2px;
      max-width: 556px;
    }
  }

  &__text {
    margin-bottom: 30.82px;

    &.text {
      font-size: 16px;

      @include up-tablet {
        font-size: 20px;
      }
    }
  }

  &__buttons {
    margin: 0 auto;
    display: grid;
    grid-template-columns: 100%;

    .button-theme {
      margin: 30px auto;
      width: 229px;
    }
  }

  .thanks-retailer {
    &__text {
      margin-bottom: 6px;
      font-family: $f-bellReg;
      font-size: 18px;
      line-height: 1.25;
      letter-spacing: 0.12px;
      text-align: center;

      @include up-tablet {
        letter-spacing: 0.15px;
      }
    }

    .retailer-description {
      &__item {
        font-family: $f-neutraBook;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        letter-spacing: 0.35px;
      }
    }
  }
}
</style>
